import {useEffect, useState} from "react";
import { Link, useLocation } from "react-router-dom";
import { DeleteAPI, GetNotificationAPI } from "../../services";
import { DateFormat, Toastify } from "../utils";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";

const Notifications = () =>
{
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [isOpened, SetIsOpened] = useState(false);
	const [firstLoad, SetFirstLoad] = useState(true);
	const [data, SetData] = useState([]);
	const location = useLocation();

	useEffect(() =>
	{
		GetDataList();
	// eslint-disable-next-line
	}, []); 

	const GetDataList = async () =>
	{
		try
		{
			const APIResponse = await GetNotificationAPI();
			if (APIResponse)
			{
				SetData(APIResponse);
				if(!firstLoad)
				{
					SetIsOpened(!isOpened);
				}
				SetFirstLoad(false);
			}
		}
		catch (ex) {}
	}

	const Remove = async (id) =>
	{
		const newData = [...data];
		const indexToRemove = newData.findIndex(item => item.id === id);
		if (indexToRemove !== -1)
		{
			const itemToRemove = newData[indexToRemove];
			if(itemToRemove.id && itemToRemove.id.length)
			{
				await DeleteAPI('Notifications', itemToRemove.id);
				newData.splice(indexToRemove, 1);
			}
		}
		SetData(newData);
	}

	const RemoveAllNotifications = () =>
	{
		DeleteAPI('Notifications', '').then(() => SetData([]));
	}

	return <>
		{isOpened ? <div className="absolute w-full h-full bg-black/20 left-0 top-0 z-30" onClick={() => SetIsOpened(false)}></div> : null}
		<div className='relative inline-flex'>
			<i className='p-2 fa fa-bell text-primary cursor-pointer' onClick={() => GetDataList()}></i>
			{data.length ?
			<span className="bg-danger px-2 py-0.5 absolute bottom-4 left-5 text-center rounded-full inline text-xs font-bold text-secondaryFont">
				{data.length >= 10 ? '10+' : data.length}
			</span>
			: null}
			{isOpened ? 
			<div className='absolute z-50 left-0 border border-primaryBorder top-6 w-96 bg-wrapperBG rounded max-h-96 overflow-y-auto'>
				<div className='bg-highlightBG border-b border-primaryBorder text-sm px-3 py-3 flex justify-between items-center'>
					<div>{language.UNREAD_NOTIFICATIONS}</div>
					{data.length > 1 ? <button className="btn btn-secondary py-1 px-3 !border-danger text-danger m-0" onClick={() => RemoveAllNotifications()}>{language.READ_ALL_NOTIFICATIONS}</button> : null }
				</div>
				{data.length ? data.map((item, index) => {
					let linkURL = '';
					if(Object.keys(settings.definitions.modules).includes(item.parent_type))
					{
						linkURL = `/detail/${item.parent_type}/${item.parent_id}`;
					}
					else if(Object.keys(settings.definitions.subpanels).includes(item.parent_type))
					{
						linkURL = `/subpanel/${item.parent_type}/${item.parent_id}`;
					}
					return <div key={index} className='border-b last:border-b-0 border-primaryBorder hover:bg-highlightBG'>
						<div className='flex items-start justify-between'>
							<Link to={linkURL} onClick={() => location.pathname === linkURL ? Toastify(language.ERROR.ALREADY_ON_PAGE) : null }>
								<div className='flex items-start'>
									<div className='px-3 py-4 w-12'><i className={(item.icon ? item.icon : 'fa fa-star')+' text-2xl text-primary rounded-full'}></i></div>
									<div className='text-right pt-4'>
										<div className='text-sm font-bold mb-1'>{language.NOTIFICATION[item.title]}</div>
										<div className='text-xs leading-5'>
											<div>{item.description}</div>
											{item.buttons && Object.keys(item.buttons).length ?
											<div>
												<Link to={item.buttons.approve} className='inline-block btn py-1 px-5'>{language.APPROVE}</Link>
												<Link to={item.buttons.decline} className='inline-block btn btn-secondary py-1 px-5 !border-danger text-danger'>{language.DECLINE}</Link>
											</div>
											: null}
										</div>
									</div>
								</div>
							</Link>
							<div className='p-3 px-4 m-2 hover:bg-danger text-danger hover:text-secondaryFont cursor-pointer rounded' onClick={() => Remove(item.id)}><i className='fa fa-trash-alt'></i></div>
						</div>
						<div className='text-end text-xs p-4 pt-2'>{item.created_by_name} - {DateFormat(item.datetime, true)}</div>
					</div>
				}) : <div className='text-sm p-4'>{language.NO_DATA}</div>}				
			</div>
			: null}
		</div>
	</>;
};

export default Notifications;